import { getPurchaseRules } from '../ProductPurchaseInfo/productPurchase';

export function getNextCartQuantity(product, currentQuantity, direction) {
  const { minimum, step } = getPurchaseRules(product);
  const parsedCurrent = Number(currentQuantity);

  if (!Number.isFinite(parsedCurrent) || parsedCurrent < minimum) return minimum;

  const remainder = (parsedCurrent - minimum) % step;

  if (direction === 'increase') {
    return remainder === 0 ? parsedCurrent + step : parsedCurrent + (step - remainder);
  }

  if (direction === 'decrease') {
    return remainder === 0
      ? Math.max(minimum, parsedCurrent - step)
      : Math.max(minimum, parsedCurrent - remainder);
  }

  return remainder === 0 ? parsedCurrent : Math.max(minimum, parsedCurrent - remainder);
}

export function validateCart(cart = []) {
  return cart.flatMap((product, index) => {
    const { minimum, step } = getPurchaseRules(product);
    const quantity = Number(product.qty);
    const code = product.code || `producto ${index + 1}`;
    const errors = [];

    if (String(product.disponibilidad || '').trim().toLowerCase() === 'no disponible') {
      errors.push(`${code}: el producto no está disponible.`);
    }

    if (!Number.isFinite(quantity) || quantity < minimum) {
      errors.push(`${code}: la cantidad mínima es ${minimum}.`);
    } else if (step > 1 && (quantity - minimum) % step !== 0) {
      errors.push(`${code}: la cantidad debe avanzar de ${step} en ${step}.`);
    }

    return errors;
  });
}
